const AuditIndexPageTitle = function (props) {
    return (
        <div className="audit-title">
            <div className="btn-go-back">
                <span>&#x2190;</span>
                <a className="btn-show-all" href={props.url}>{`${__('Go back to')} ${props.title}`}</a>
            </div>
            <h3 className="page-body-title">{`${__('History')} - ${props.title}`}</h3>
        </div>
    )
}

export default AuditIndexPageTitle;